import { Sparkles } from "lucide-react";
import BlockList from "../BlockList";
import InlineFileAttachments from "../../files/InlineFileAttachments";

/**
 * Master v5 Prompt 9 — Guided Practice renderer. Block-based (long_text),
 * the exercise-drafting surface — one immutable InteractionAttempt is
 * created at Submit, pointing at the companion WorkDocument's frozen
 * version, never a duplicate copy of the text.
 *
 * Master v5 Prompt 11 — a direct "attach a file" entry point lives right
 * here too: files attached while working on the exercise link to this
 * Interaction Instance (`interaction_attempt` itself is immutable, created
 * only once at Submit, so mid-exercise attachments target the ongoing
 * Instance, not a not-yet-created Attempt).
 */
export default function GuidedPracticeRenderer({ workspaceId, docId, instanceId, instructions, isViewAsClient, isInstanceLocked }) {
  return (
    <div data-testid="renderer-guided-practice">
      <div className="flex items-center gap-2 text-ink-soft mb-3">
        <Sparkles size={16} /><span className="text-sm uppercase tracking-wide">Guided Practice</span>
      </div>
      {instructions && <p className="text-ink-soft text-sm mb-4" data-testid="renderer-guided-practice-instructions">{instructions}</p>}
      <BlockList workspaceId={workspaceId} docId={docId} isViewAsClient={isViewAsClient} isInstanceLocked={isInstanceLocked} />
      {!isViewAsClient && instanceId && (
        <div className="mt-4 pt-3 border-t border-ink/10">
          <InlineFileAttachments workspaceId={workspaceId} targetType="interaction_instance" targetId={instanceId} label="this exercise" />
        </div>
      )}
    </div>
  );
}
